import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

class ToBottomNoData extends React.PureComponent {
    static propTypes = {
        title: PropTypes.string,
        isMarginTop: PropTypes.bool,
    };

    render() {
        const { title, isMarginTop } = this.props;

        return (
            <div className={isMarginTop ? styles.title_mt : styles.title}>
                <div>{title}</div>
            </div>
        );
    }
}

export default ToBottomNoData;
